import { DatasourceDataTypeUrl } from 'jamespot-user-api';

export function ensureIsObject(object: unknown): object is object {
    return typeof object === 'object' && object !== null;
}

// Considere this as the basic title/url format
export function ensureIsUrl(object: unknown): object is DatasourceDataTypeUrl {
    if (ensureIsObject(object) && 'url' in object && 'title' in object) {
        return true;
    }
    return false;
}

export function ensureIsStringOrNumber(value: unknown): value is string {
    return typeof value === 'string' || typeof value === 'number';
}

export function ensureIsNumber(value: unknown): value is number {
    return typeof value === 'number';
}
